import { ADDRESS_FINDER_LOCAL_URL, ADDRESS_FINDER_DEV_URL, ADDRESS_FINDER_TEST_URL, ADDRESS_FINDER_PREPROD_URL, ADDRESS_FINDER_PROD_URL } from '../utils/constants';
var apiConfig = {
  getAddressFinderApiUrl: function getAddressFinderApiUrl() {
    var baseUrl = "https://".concat(window.location.href.split('/')[2]);

    if (baseUrl.toLowerCase().includes('localhost')) {
      return ADDRESS_FINDER_LOCAL_URL;
    }

    if (baseUrl.toLowerCase().includes('-dev.')) {
      return ADDRESS_FINDER_DEV_URL;
    }

    if (baseUrl.toLowerCase().includes('-test.')) {
      return ADDRESS_FINDER_TEST_URL;
    }

    if (baseUrl.toLowerCase().includes('-preprod.')) {
      return ADDRESS_FINDER_PREPROD_URL;
    }

    if (baseUrl.toLowerCase().includes('.sainsburys.co.uk')) {
      return ADDRESS_FINDER_PROD_URL;
    } else {
      console.log('Error setting address finder api url');
      return '';
    }
  }
};
export default apiConfig;